import React from "react";
import {HStack, useRadioGroup} from "@chakra-ui/react";
import RadioCard from "./RadioCard.tsx";
import iso6391 from "iso-639-1";

interface RadioCardsProps {
  options: string[];
  setTargetLang: (value: string) => void;
}

const RadioCards: React.FC<RadioCardsProps> = ({options, setTargetLang}) => {

  const {getRootProps, getRadioProps} = useRadioGroup({
    name: 'targetLang',
    defaultValue: options[0],
    onChange: setTargetLang,
  })

  const group = getRootProps()

  return (
    <HStack
      {...group}
      overflowX="auto"
      css={{
        scrollbarWidth: "none", // Firefox
        msOverflowStyle: "none", // IE/Edge
        "&::-webkit-scrollbar": {
          display: "none", // Chrome/Safari
        },
      }}
    >
      {[...options].map((value) => {
        const radio = getRadioProps({value})
        return (
          <RadioCard key={value} {...radio}>
            {iso6391.getName(value)}
          </RadioCard>
        )
      })}
    </HStack>
  )
}

export default RadioCards;